import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from '../../../../style/styled';
import { selectModalData } from '../../../../store/modal/selectors';
import { SCREEN_WIDTH_BREAK_SMALL } from '../../../../style/SIZES';
import { AddItemsToExistingTourPlan } from './AddItemsToExistingTourPlan';
import { AddItemToNewTourPlan } from './AddItemToNewTourPlan';

// Add a tour or a place to a tour plan.
// Part of street escapes feature which is disabled for now.
export const AddItemToTourPlan = () => {
  const { t } = useTranslation();
  const modalData = useSelector(selectModalData) || {};

  const placeID = modalData.placeID;
  const tourID = modalData.tourID;

  if (!placeID && !tourID) {
    return null;
  }

  // TODO: create a new plan (low priority)

  return (
    <Container>
      <Section>
        <Title>
          {t(tourID ? 'Adding tour to tour plan' : 'Adding place to tour plan')}
        </Title>
      </Section>

      <Section>
        <AddItemsToExistingTourPlan tourID={tourID} placeID={placeID} />
        <AddItemToNewTourPlan tourID={tourID} placeID={placeID} />
      </Section>
    </Container>
  );
};

export default AddItemToTourPlan;

const Container = styled.div`
  padding: 8px;
  margin: 0 auto;
  width: 300px;

  @media only screen and (max-width: ${SCREEN_WIDTH_BREAK_SMALL}px) {
    width: 95%;
  }
`;

const Section = styled.section`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.h4`
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 20px;
`;
